export { default as ConfirmDialogComponent } from "./ConfirmDialogComponent";
